module.exports = __webpack_public_path__ + "img/forest_01.jpg";